import { PositionedSnackbar } from "./PositionedSnackbar";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

export const SuccessSnackbar = ({ open, onClose, title = "Éxito", message, position = { vertical: "top", horizontal: "center" }, sx }) => {
  return (
    <PositionedSnackbar open={open} onClose={onClose} position={position}>
      <Alert
        onClose={onClose}
        severity="success"
        variant="filled"
        sx={{
          backgroundColor: "rgba(56, 142, 60, 0.8)",
          "& .MuiAlert-icon": {
            color: "#fff",
          },
          color: "#fff",
          width: "fit-content",
          minWidth: "300px",
          maxWidth: "600px",
          marginTop: "45px",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          ...sx,
        }}
      >
        <AlertTitle sx={{ fontWeight: "bold" }}>{title}</AlertTitle>
        {message}
      </Alert>
    </PositionedSnackbar>
  );
};
